/** Shopify CDN: Minification failed

Line 16:2 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 17:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 40:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 45:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 47:8 Transforming const to the configured target environment ("es5") is not supported yet
Line 61:8 Transforming const to the configured target environment ("es5") is not supported yet
Line 80:16 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 87:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 92:17 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 101:18 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
if (!customElements.get('slideshow-swiper')) {
  class Slideshow extends HTMLElement {
    constructor() {
      super();

      this.defaultConfig = {
        updateOnWindowResize: true,
        speed: 300,
        a11y: {
          enabled: false,
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide',
          lastSlideMessage: 'This is the last slide',
          paginationBulletMessage: 'Go to slide {{index}}',
          slideLabelMessage: '{{index}} / {{slidesLength}}'
        },
        on: {
          init: this.onSwiperInit.bind(this),
          slideChange: this.onSlideChange.bind(this),
          // resize: this.onSwiperResize.bind(this),
          afterInit: this.afterInit.bind(this),
          paginationUpdate: this.paginationUpdate.bind(this)
        }
      };

      this.debounce = null;

      window.addEventListener('resize', this.onSwiperResize.bind(this));
    }

    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.settings = JSON.parse(this.getAttribute('data-settings') || '{}');
      this.pagination_type = this.settings.pagination?.type

      this.swiper = new Swiper(this, Object.assign({}, this.defaultConfig, this.getSettings(this.settings)));
    }

    getSettings(settings) {
      if (settings.thumbs && settings.thumbs.swiper) {
        const thumbnails = document.querySelector(settings.thumbs.swiper);

        if (thumbnails) {
          if (thumbnails.swiper) {
            this.settings.thumbs.swiper = thumbnails.swiper;

            thumbnails.swiper.on('slideChange', (swiper) => {
              const { activeIndex } = swiper;

              this.swiper.slideTo(activeIndex);
            });
          } else {
            this.settings.thumbs.swiper = false;

            thumbnails.addEventListener('swiperInstanceInitialized', () => {
              this.swiper.thumbs.swiper = thumbnails.swiper;
              this.swiper.thumbs.init();

              this.swiper.thumbs.swiper.on('slideChange', (swiper) => {
                const { activeIndex } = swiper;

                this.swiper.slideTo(activeIndex);
              });
            })
          }
        }
      } else if (settings.controller && settings.controller.control) {
        const controller = document.querySelector(settings.controller.control);

        if (controller) {
          if (controller.swiper) {
            this.settings.controller.control = controller.swiper;
          } else {
            this.settings.controller.control = false;

            controller.addEventListener('swiperInstanceInitialized', () => {
              this.swiper.controller.control = controller.swiper;
            })
          }
        }
      }

      if (settings.pagination?.type === 'custom-with-zero' && this.sectionId) {
        this.settings.pagination =  {
          el: `.swiper-pagination-${this.sectionId}`,
          type: 'custom',
          renderCustom: function (swiper, current, total) {

            if(current <= 9) current = `0${current}`
            if(total <= 9) total = `0${total}`

            return current + ' <span> / </span> ' + total;
          }
        }
      }

      if (settings.pagination?.type === 'custom-tab' && this.sectionId) {
        console.log('this.swiper', this);

        const checkMark = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">\n' +
          '<circle cx="12" cy="12" r="11" fill="white" stroke="#1C1C1C" stroke-width="2"/>\n' +
          '<path d="M6 11.4298L11.2815 15.3335L17.4815 7.06679" stroke="#1C1C1C" stroke-width="3"/>\n' +
          '</svg>'

        this.settings.pagination =  {
          el: `.swiper-pagination-${this.sectionId}`,
          clickable: true,
          type: 'bullets',
          // dynamicBullets: true,
          // dynamicMainBullets: 5,
          renderBullet: function (index, className) {
            return '<div class="' + className + '"><span>' + checkMark + this.slides[index].dataset.title +  '</span></div>';
          }
        }
      }

      return settings;
    }

    onSwiperInit(swiper) {
      //Swiper init logic
      setTimeout(() => {
        this.dispatchEvent(new CustomEvent('swiperInstanceInitialized'));
      }, 1000);
    }

    afterInit(swiper) {
      //Swiper after init logic
    }

    paginationUpdate(swiper, paginationEl) {
      let activeBullet = paginationEl.querySelector('.swiper-pagination-bullet-active');

      if (!activeBullet) return; // If no active element found, exit

      const elementLeftPosition = activeBullet.getBoundingClientRect().left - paginationEl.getBoundingClientRect().left,
            elementRightPosition = activeBullet.getBoundingClientRect().right - paginationEl.getBoundingClientRect().left,
            paginationElWidth = paginationEl.getBoundingClientRect().width;

      if (elementRightPosition > paginationElWidth) {
        paginationEl.scrollLeft +=  elementRightPosition - paginationElWidth + (paginationElWidth / 8)
      } else if (elementLeftPosition < 0) {
        paginationEl.scrollLeft += (elementLeftPosition - (paginationElWidth / 8))
      }
    }

    onSlideChange(swiper) {

      //Swiper slideChange logic
      if (swiper.thumbs && swiper.thumbs.swiper) {
        swiper.thumbs.swiper.slideTo(swiper.activeIndex);
      }
    }

    onSwiperResize(event) {
      if (this.pagination_type === 'custom-with-zero' && this.swiper) {
        clearTimeout(this.debounce);

        this.debounce= setTimeout(() => {
          this.swiper.wrapperEl.removeAttribute('style')
        }, 300);
      }
    }
  }

  customElements.define('slideshow-swiper', Slideshow);
}
